var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category",attrs:{"id":"category"}},[_c('p',[_vm._v("Category: "+_vm._s(_vm.$route.params.categorySlug))])])}
var staticRenderFns = []

export { render, staticRenderFns }